import React, { useRef, useState } from 'react';
import { useMarkdown } from '../../hooks/useMarkdown';
import './Editor.css'; // 导入样式文件

// 示例Markdown文本
const SAMPLE_MARKDOWN = `# Markdown示例
这是一个**Markdown**示例文件，包含一些_格式化_文本。

## 公式示例
行内公式: \\( E=mc^2 \\)

块级公式:
\\[
\\sum_{i=1}^{n} i = \\frac{n(n+1)}{2}
\\]

## 表格示例
| 姓名 | 年龄 | 职业 |
|------|------|------|
| 张三 | 25   | 工程师 |
| 李四 | 30   | 设计师 |
`;

const Editor: React.FC = () => {
    const { markdown, setMarkdown, loadMarkdownFromFile, convertAndRender, convertFormulas } = useMarkdown();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [debugInfo, setDebugInfo] = useState<string>('');

    const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            loadMarkdownFromFile(file);
            // 显示文件名
            const fileName = document.getElementById('file-name');
            if (fileName) {
                fileName.textContent = file.name;
            }
        }
    };

    const loadSampleMarkdown = () => {
        setMarkdown(SAMPLE_MARKDOWN);
        const fileName = document.getElementById('file-name');
        if (fileName) {
            fileName.textContent = "sample.md";
        }
    };

    const handleDebug = () => {
        try {
            // 测试转换过程
            const converted = convertFormulas(markdown);
            setDebugInfo(
                `原始长度: ${markdown.length}\n转换后长度: ${converted.length}\n\n` +
                `原始内容片段:\n${markdown.substring(0, 300)}...\n\n` +
                `转换后内容片段:\n${converted.substring(0, 300)}...`
            );
        } catch (error) {
            setDebugInfo(`转换出错: ${error}`);
        }
    };

    return (
        <div className="editor-container">
            <h2 className="editor-title">Markdown 编辑器</h2>
            <div className="editor-actions">
                <input 
                    type="file" 
                    accept=".md,.txt" 
                    onChange={handleUpload} 
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    id="markdown-file-upload"
                />
                <button 
                    onClick={() => fileInputRef.current?.click()}
                    className="btn btn-primary"
                    title="选择Markdown文件"
                >
                    <span className="btn-icon">📄</span> 选择文件
                </button>
                
                <button 
                    onClick={loadSampleMarkdown}
                    className="btn btn-success"
                    title="加载示例Markdown"
                >
                    <span className="btn-icon">✨</span> 加载示例
                </button>
                
                <div className="file-name-container">
                    <span className="file-icon">📎</span>
                    <span id="file-name">未选择任何文件</span>
                </div>
            </div>
            
            <textarea
                value={markdown}
                onChange={(e) => setMarkdown(e.target.value)}
                rows={10}
                cols={50}
                placeholder="在此输入Markdown文本..."
                className="markdown-textarea"
            />
            
            <div className="editor-footer">
                <div className="footer-actions">
                    <button 
                        className="btn btn-primary"
                        onClick={() => {
                            convertAndRender();
                            console.log("转换并渲染");
                        }}
                        title="转换并渲染Markdown"
                    >
                        <span className="btn-icon">🔄</span> 转换并渲染
                    </button>
                    
                    <button 
                        className="btn btn-secondary"
                        onClick={handleDebug}
                        title="显示转换调试信息"
                    >
                        <span className="btn-icon">🔍</span> 调试转换
                    </button>
                </div>
                <span className="char-count">{markdown ? markdown.length : 0} 字符</span>
            </div>

            {debugInfo && (
                <div className="debug-panel">
                    <h4>调试信息</h4>
                    <pre>{debugInfo}</pre>
                </div>
            )}
        </div>
    );
};

export default Editor;